import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "./useAuthContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { USERS_BASE_URL } from "../services/SignUpService";

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { dispatch } = useAuthContext();
  const navigate = useNavigate();
  const signup = async (firstName, lastName, email, password) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${USERS_BASE_URL}/api/users/register`,
        {
          firstName,
          lastName,
          email,
          password,
        }
      );

      // Handle success scenario
      Swal.fire({
        position: "top-center",
        icon: "success",
        title: "Success",
        text: "Registered successfully!!",
        showConfirmButton: false,
        timer: 2000,
      });

      localStorage.removeItem("user");
      setIsLoading(false);
      navigate("/api/users/login");
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setError(err.response.data.message || "Signup failed!"); // Set error message
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };

  return { signup, isLoading, error };
};
